<template>
  <v-container
    class="fill-height section-container"
    fluid
    style="display: flex; justify-content: center;"
  >
    <v-row align="start" justify="center" style="margin: 0">
      <v-data-table
        v-if="$store.state.headers"
        :headers="computedHeaders"
        hide-default-header
        :search="search"
        :items="user_techReqs"
        :loading="loading_requests"
        class="hidden-sm-and-down"
        sort-by="id"
        sort-desc
        style="width: 100%"
        loading-text="Cargando listado..."
        no-data-text="No existen prácticas agendadas"
      >
        <template 
          v-slot:header>
          <tr>
            <th v-show="showColumn('request.display_id')">ID</th>
            <th v-show="showColumn('request.status_request.id')">ESTADO</th>
            <th v-show="showColumn('request.service.rubro.name')">RUBRO</th>
            <th v-show="showColumn('request.service.name')">SERVICIO</th>
            <th v-show="showClientColumn('request.client.full_name')">
              CLIENTE
            </th>
            <th v-show="showColumn('request.full_address')">DIRECCION</th>
            <th v-show="showColumn('request.neighborhood.city.name')">CIUDAD</th>
          </tr>
        </template>
        <template v-slot:item="{ item }">
          <tr v-if="item.request.is_urgency" class="urgent header">
            <td :colspan="7" style="height: 30px">
              <b style="color: #FF5252"
                ><span style="font-size: 12px">&#x21E9;</span> PEDIDO URGENTE
                <span style="font-size: 12px">&#x21E9;</span></b
              >
            </td>
          </tr>
          <tr
            @click="showRequest(item)"
            style="cursor: pointer"
            v-bind:class="{ urgent: item.request.is_urgency }"
          >
            <td v-show="showColumn('request.display_id')">
              <div style="margin: 0" class="id-column-event">
                <span>{{ item.request.display_id }}</span>
                  <template v-if="$store.state.app_display_scheme">
                    <img
                      v-if="item.request.scheme == 'asistencia'"
                      class="mr-2 id-icon-event"
                      src="../icons/asistencia.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="item.request.scheme == 'cliente-final'"
                      class="mr-2 id-icon-event"
                      src="../icons/clientefinal.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="item.request.scheme == 'corpo'"
                      class="mr-2 id-icon-event"
                      src="../icons/corporativo.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="item.request.scheme == 'fletes'"
                      class="mr-2 id-icon-event"
                      src="../icons/fletes.png"
                      height="20"
                      width="20"
                    />
                    <img
                      v-if="item.request.scheme == 'inmobiliaria'"
                      class="mr-2 id-icon-event"
                      src="../icons/inmobiliaria.png"
                      height="20"
                      width="20"
                    />
                  </template>
                
              </div>
            </td>
            <td v-show="showColumn('request.status_request.id')">
              {{ item.request.status_request.description }}
            </td>
            <td v-show="showColumn('request.service.rubro.name')">
              {{ item.request.service.rubro.name }}
            </td>
            <td v-show="showColumn('request.service.name')">
              {{ item.request.service.name }}
            </td>
            <td v-show="showClientColumn('request.client.full_name')">
              {{
                item.request.client
                  ? item.request.client.full_name
                  : "No disponible"
              }}
            </td>
            <td v-show="showColumn('request.full_address')">
              {{ item.request.full_address }}
            </td>
            <td v-show="showColumn('request.neighborhood.city.name')">
              {{
                item.request.neighborhood.city
                    ? item.request.neighborhood.city.name
                    : "No disponible"
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
      
      <v-data-table
        :loading="loading_requests"
        class="hidden-md-and-up"
        :headers="computedHeaders"
        :search="search"
        :items="user_techReqs"
        must-sort
        sort-desc
        sort-by="id"
        style="width: 100%"
        :items-per-page="-1"
        hide-default-header
        hide-default-footer
        loading-text="Cargando listado..."
        no-data-text="No existen prácticas agendadas"
      >
        <template 
          v-slot:item="{ item }" 
        >
          <RequestItem :techReq="item" @show-request="showRequest(item)" />
        </template>
        

      </v-data-table>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import RequestItem from "./RequestItem";
import HeadersRequests from "../assets/js/headersRequests";

export default {
  name: "request-list",
  components: {
    RequestItem
  },
  data() {
    return {
      headers: null,
      headersRequests: HeadersRequests,
      search: null,
      requestList: [],
      error_message: false,
      setTimeout: null,
      selectedItem: {}
    };
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "perform_search") {
        this.search = state.search;
      }
      if (mutation.type === "reset_search") {
        this.search = state.search;
      }
    });
  },
  mounted() {
    window.scrollTo(0, 0);

    this.setHeaders();

    if (this.$store.state.request_status) {
      this.$store.commit(
        "filter_requests_by_status",
        this.$store.state.request_status
      );
    } else {
      this.$store.commit("filter_requests_by_status", null);
    }

    this.$store.commit("set_app_title", "Pedidos");
  },
  methods: {
    setHeaders() {
      const _headers = localStorage.getItem("headersRequests");
      let headers;
      if (_headers) {
        headers = JSON.parse(_headers);
      } else {
        localStorage.setItem(
          "headersRequests",
          JSON.stringify(this.headersRequests)
        );
        headers = this.headersRequests;
      }
      this.injectFilters(headers);
      this.$store.commit("set_headers", headers);
    },
    injectFilters(headers) {
      const filter = value => {
        if (!this.$store.state.request_status) return true;
        return value === this.$store.state.request_status;
      };
      const index = headers.findIndex(
        item => item.value === "request.status_request.id"
      );
      headers[index].filter = filter;
      const indexB = this.headersRequests.findIndex(
        item => item.value === "request.status_request.id"
      );
      this.headersRequests[indexB].filter = filter;
    },
    showRequest(techReq) {
      this.$router.push({
        name: "request-detail",
        query: { requestId: techReq.request.id }
      });
    },
    showColumn(value) {
      const item = this.$store.state.headers.find(function(element) {
        return element.value === value;
      });
      if (item) return item.show;
      return null;
    },
    showClientColumn(value) {
      const item = this.$store.state.headers.find(function(element) {
        return element.value === value;
      });
      if (item && this.$store.state.app_display_username) return item.show;
      return null;
    }
  },
  computed: {
    computedHeaders: function() {
      let _headers = this.headersRequests;
      if (!this.$store.state.app_display_username) {
        _headers = _headers.filter(
          item => item.value !== "request.client.full_name"
        );
      }
      return _headers;
    },
    ...mapState(["user_techReqs", "loading_requests"])
  },
  watch: {
    "$store.state.headers": function(val, old) {
      localStorage.setItem(
        "headersRequests",
        JSON.stringify(this.$store.state.headers)
      );
    },
    "$store.state.updateHeaders": function(val, old) {
      this.setHeaders();
    }
  }
};
</script>

<style>
.id-icon-event{
  width: 25px;
}
.id-column-event {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: baseline;
}
.urgent {
  background-color: #fffbcb;
}
.header:hover {
  background-color: #fffbcb !important;
}
@media (max-width: 959px) {
  .v-divider {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .hidden-sm {
    display: none;
  }
  .section-container {
    padding: 0;
  }
}
@media (min-width: 960px) {
  .v-divider {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .hidden-lg {
    display: none;
  }
}
.v-list-item__subtitle,
.v-list-item__title {
  overflow: visible !important;
}
.v-data-footer {
  padding: 0 !important;
}
.v-application--is-ltr .v-data-footer__select {
  margin-right: 0 !important;
}
</style>
